import isDate from 'lodash/isDate.js';
import isString from 'lodash/isString.js';
import { arrayHasItems, pageForDate, getMaxPage, datesAreEqual, addPages } from '../helpers.js';

class MultiplePicker {
  constructor(_ref) {
    let {
      format,
      parse
    } = _ref;
    Object.assign(this, {
      format,
      parse
    });
  }
  hasValue(value) {
    return arrayHasItems(value);
  }
  formatValue(value) {
    if (this.hasValue(value)) {
      return value.map(val => this.format(val)).join(', ');
    }
    return '';
  }
  parseValue(text) {
    if (!isString(text)) {
      return [];
    }
    return text.split(',').map(section => this.parse(section)).filter(date => isDate(date));
  }
  normalize(value) {
    if (!this.hasValue(value)) {
      return [];
    }
    return [...new Set(value)].sort((a, b) => a.getTime() - b.getTime());
  }
  filterDisabled(_ref2) {
    let {
      value,
      isRequired,
      disabled,
      fallbackValue
    } = _ref2;
    if (!this.hasValue(value)) {
      return [];
    }
    if (!disabled) {
      return value;
    }
    const newValue = value.filter(date => !disabled.intersectsDate(date));
    if (!this.hasValue(newValue) && isRequired) {
      return fallbackValue;
    }
    return newValue;
  }
  valuesAreEqual(valueA, valueB) {
    const aHasItems = this.hasValue(valueA);
    const bHasItems = this.hasValue(valueB);
    if (!aHasItems && !bHasItems) {
      return true;
    }
    if (aHasItems !== bHasItems || valueA.length !== valueB.length) {
      return false;
    }
    return valueA.some(val => !valueB.includes(val));
  }
  getPageRange(value) {
    if (!this.hasValue(value)) {
      return null;
    }
    const from = pageForDate(value[0]);
    const to = getMaxPage(pageForDate([].concat(value).pop()), addPages(from, 1));
    return {
      from,
      to
    };
  }
  handleDayClick(day, picker) {
    if (!picker.dateIsValid(day.date)) {
      return;
    }
    let value = [];
    if (!this.hasValue(picker.model)) {
      value = [day.date];
    } else if (picker.model.some(date => date.getTime() === day.dateTime)) {
      value = picker.model.filter(date => !datesAreEqual(date, day.date));
      if (!this.hasValue(value) && picker.isRequired) {
        value = [day.date];
      }
    } else {
      value = [...picker.model, day.date];
    }
    picker.model = this.normalize(value);
  }
  handleDayMouseEnter() {}
}

export { MultiplePicker as default };
//# sourceMappingURL=multiple.js.map
